export default __webpack_public_path__ + "static/media/Discord-Logo.1a0c3dc4.svg";